import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';

@Component({
  selector: 'app-export-time-logs',
  templateUrl: './export-time-logs.component.html',
  styleUrls: ['./export-time-logs.component.scss']
})
export class ExportTimeLogsComponent implements OnInit {
  datefrom: NgbDateStruct = {
    year: Number(moment().format('YYYY')),
    month: Number(moment().format('MM')),
    day: Number(moment().format('DD'))
  };
  dateto: NgbDateStruct = {
    year: Number(moment().format('YYYY')),
    month: Number(moment().format('MM')),
    day: Number(moment().format('DD'))
  };
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private spinner: NgxSpinnerService
  ) { 
  }

  ngOnInit(): void {
  }

  close() {
    this.activeModal.close();
  }

  async exportData(): Promise<void> {
    this.spinner.show();
    const df = this.datefrom.year.toString() + '-' + this.datefrom.month.toString() + '-' + this.datefrom.day.toString();
    const dt = this.dateto.year.toString() + '-' + this.dateto.month.toString() + '-' + this.dateto.day.toString();
    await this.daytranService.exportTimelogs({datefrom: df, dateto: dt});
    await this.spinner.hide();
  }

}
